import script from "./promotionCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./promotionCard.vue?vue&type=script&setup=true&lang=ts"

import "./promotionCard.vue?vue&type=style&index=0&id=365ad59a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-365ad59a"]])

export default __exports__